<div class="flex flex-col h-screen overflow-hidden bg-sand">
  <admin-navbar></admin-navbar>
  <h1 class="mx-12 mt-4 mb-1 text-2xl font-bold shrink-0">{{ pageTitle }}</h1>
  <div class="flex flex-col flex-1 min-h-0 mx-12 mt-2">
    <div class="flex flex-col flex-1 min-h-0 w-full bg-white 4xl:mx-none">
      <!-- <admin-sidebar></admin-sidebar> -->
      <div class="flex flex-col flex-1 min-h-0 w-full p-4 bg-base-300">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<admin-footer></admin-footer>
